import { render, staticRenderFns } from "./SoleOwnershipSale.vue?vue&type=template&id=52ff48f4"
import script from "./SoleOwnershipSale.vue?vue&type=script&lang=js"
export * from "./SoleOwnershipSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports